/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loadingbusinesses1Inputs */

const en_loadingbusinesses1 = /** @type {(inputs: Loadingbusinesses1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading businesses...`)
};

const de_loadingbusinesses1 = /** @type {(inputs: Loadingbusinesses1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen werden geladen…`)
};

/**
* | output |
* | --- |
* | "Loading businesses..." |
*
* @param {Loadingbusinesses1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const loadingbusinesses1 = /** @type {((inputs?: Loadingbusinesses1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loadingbusinesses1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loadingbusinesses1(inputs)
	return de_loadingbusinesses1(inputs)
});
export { loadingbusinesses1 as "loadingBusinesses" }